<h2 mat-dialog-title>Recuperar contraseña</h2>

<mat-dialog-content>

  <p class="info-text">
    Se enviará una clave temporal al correo registrado del usuario.
  </p>

  <form [formGroup]="form">

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>N° de usuario</mat-label>

      <input matInput formControlName="usuario" placeholder="Ingrese su número de usuario">

      <mat-error *ngIf="form.get('usuario')?.hasError('required')">
        Campo requerido
      </mat-error>

      <mat-error *ngIf="form.get('usuario')?.hasError('pattern')">
        Solo se permiten números
      </mat-error>

    </mat-form-field>


    <div *ngIf="backendMessage" class="backend-message">
      {{ backendMessage }}
    </div>

    <div *ngIf="correoEnviado" class="correo-info">
      Correo enviado a : {{ correoEnviado }}
    </div>

  </form>

</mat-dialog-content>

<mat-dialog-actions align="end">

  <!-- ESTADO NORMAL -->
  <ng-container *ngIf="!isSuccess">

    <button mat-button (click)="cerrar()" [disabled]="isProcessing">
      Cancelar
    </button>

    <button mat-raised-button color="primary" (click)="enviarCodigo()" [disabled]="form.invalid || isProcessing">
      Enviar código
    </button>

  </ng-container>

  <!-- ✔ ESTADO ÉXITO -->
<ng-container *ngIf="isSuccess">

  <button mat-stroked-button (click)="cerrar()">
  Cerrar
</button>

  <button
  mat-raised-button
  color="primary"
  (click)="reenviarCodigo()"
  [disabled]="isProcessing || retryCount >= maxRetries">

  Reenviar código

</button>

</ng-container>

<div *ngIf="retryCount >= maxRetries" class="backend-message warning">
  Se ha excedido el límite de reenvíos.
</div>

</mat-dialog-actions>